import { ApiContract, HttpMethods } from '@tc/http';
import { Api } from '../../configuration/Api';
import { ISavedSearch } from '../../../features/search/models/ISavedSearch';

/**
 * Contract for saving a search.
 */
@ApiContract({ endpoint: Api.saveSearch, httpMethod: HttpMethods.post })
export class ApiSaveSearch {
  constructor(savedSearch: ISavedSearch) {
    Object.assign(this, savedSearch);
  }
}
